import React from 'react';
import { Card, CardBody, CardHeader, CardFooter, ButtonGroup } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

interface PCCardActionProps {
  id: string;
  values?: any;
  children: React.ReactElement;
  footer?(): React.ReactNode;
  actions?(): React.ReactNode;
}

/**
 * @author Jungwirth
 */
export const PCCardAction: React.FC<PCCardActionProps> = (props: Readonly<PCCardActionProps>): JSX.Element => {
  const { id, values, children, footer, actions } = props;

  const cardActions = (
    <ButtonGroup>
      {actions ? actions(): ''}
    </ButtonGroup>
  );

  const cardFooter = (
    <CardFooter>
      {footer ? footer(): ''}
    </CardFooter>
  );

  return (
    <Card className="mb-4">
      <CardHeader className="bg-primary text-light">
        <div className="d-flex align-items-center">
          <div className="text-truncate flex-fill">
            <FormattedMessage id={id} values={values} />
          </div>
          {actions &&
            cardActions}
        </div>
      </CardHeader>
      <CardBody>
        {children}
      </CardBody>
      {footer &&
        cardFooter}
    </Card>
  );
};
